import { render } from "./ThePageHeader.vue?vue&type=template&id=0aab28cb&ts=true"
import script from "./ThePageHeader.vue?vue&type=script&lang=ts"
export * from "./ThePageHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__